/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { Component } from '@/Constants/Component'

/**************************************************************************************************/
/** @import Helpers/Components                                                                   **/
/**************************************************************************************************/
import { InputSelect } from '@/Helpers/Components/DataForm/InputSelect'
import { InputText } from '@/Helpers/Components/DataForm/InputText'

/**************************************************************************************************/
/** @import Helpers/Utils                                                                        **/
/**************************************************************************************************/
import { TypesHelper } from '@/Helpers/Utils/TypesHelper'

/**************************************************************************************************/
/** @internal Const @name rutStateValidator                                                      **/
/**************************************************************************************************/
const rutStateValidator = (self: any) =>
{
	if (self.value === '') return null
	return TypesHelper.isStringValidRutFormat(self.value)
}

/**************************************************************************************************/
/** @internal Const @name rutKeyUpEvent                                                          **/
/**************************************************************************************************/
const rutKeyUpEvent = (self: any) =>
{
	if (self.value === '') return
	self.value = TypesHelper.toStringValidRutFormat(self.value, '')
}

/**************************************************************************************************/
/** @export Object @name DataFormElements                                                        **/
/**************************************************************************************************/
export default <any>
{
	Companies:
	{
		params:
		{
			currentTab: 'companies',
			numColumns: 2,
		},
		tabs:
		[
			{
				header:
				{
					key: 'companies',
					text:
					{
						onInsert: 'Nuevo Cliente',
						onUpdate: 'Actualizar Cliente'
					}
				},
				columns:
				[
					new InputText('code', 'Código')
						.setParamsReadOnly(Component.Actions.UPDATE)
					,
					new InputSelect('region', 'Región'),
					new InputText('rut', 'Rut')
						.addEvent('keyup', rutKeyUpEvent)
						.setParamsPlaceHolder('Ej: 99888777-6')
						.setParamsReadOnly(Component.Actions.UPDATE)
						.setParamsState(rutStateValidator)
					,
					new InputSelect('commune', 'Comuna')
						.setParamsPlaceHolder('- Seleccione una Región -')
					,
					new InputText('name', 'Razón Social'),
					new InputSelect('isClient', '¿Es Cliente?', ['Sí', 'No']),
					new InputText('address', 'Dirección de Facturación'),
					new InputSelect('isValid', '¿Esta Activa?', ['Sí', 'No']),
					new InputSelect('type', 'Tipo', ['Cliente', 'Proveedor', 'Sucursal Interna']),
				]
			}
		]
	},
	Storages:
	{
		params:
		{
			currentTab: 'storages',
			numColumns: 2,
		},
		tabs:
		[
			{
				header:
				{
					key: 'storages',
					text:
					{
						onInsert: 'Gestión Acceso QR Planta',
						onUpdate: 'Gestión Acceso QR Planta'
					}
				},
				columns:
				[
					new InputText('code', 'Código Planta').setParamsReadOnly(Component.Actions.UPDATE).setParamsState(() => null),
					new InputText('name', 'Nombre Planta').setParamsReadOnly(Component.Actions.UPDATE).setParamsState(() => null),
					new InputText('companyName', 'Cliente').setParamsReadOnly(Component.Actions.UPDATE).setParamsState(() => null),
					new InputText('accessTotem', 'Acceso Planta QR').setParamsReadOnly(Component.Actions.UPDATE).setParamsState(() => null),
				]
			}
		]
	}
}